import { render, staticRenderFns } from "./comChart.vue?vue&type=template&id=3f8431c6&"
import script from "./comChart.vue?vue&type=script&lang=js&"
export * from "./comChart.vue?vue&type=script&lang=js&"
import style0 from "./comChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports